








































import Vue from "vue";
import { Carousel, Slide } from "vue-carousel";

import IconRight from "@/components/icons/IconRight.vue";

import { IState } from "./interfaces";

export default Vue.extend({
  name: "ReviewsSlider",
  components: {
    Carousel,
    Slide,
    IconRight,
  },
  props: {
    items: { type: Array, default: () => [] },
  },
  data(): IState {
    return {
      current: 0,
      options: {
        perPage: 1,
        paginationEnabled: false,
        mouseDrag: false,
      },
    };
  },
  methods: {
    next() {
      if (this.current < this.items.length / this.options.perPage - 1) {
        this.current++;
      } else {
        this.current = 0;
      }
    },
  },
});
